import React from "react";
import 'moment-timezone';
import moment from "moment";

const TimeDisplay = ({dateTime, classNameType=""}: {dateTime: Date | string; classNameType?: string}) => {

    let time = moment(dateTime);

  return <span className={classNameType}>{time.format("HH.mm")}</span>;
}

export default TimeDisplay;